var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function({hover}){return [_c('div',{staticClass:"container shadow white"},[_c('app-icon',{attrs:{"color":"orange","disabled":_vm.disabled,"icon":_vm.icon,"size":"32"}})],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }